import React, { useEffect, useState } from 'react';
import './ProgressBar.css';

const ProgressBar = ({ percentage, text }) => {
  const [currentPercentage, setCurrentPercentage] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = percentage;
    const duration = 1000; // Duration in milliseconds
    const stepTime = 20;
    const step = (end - start) / (duration / stepTime);

    const interval = setInterval(() => {
      start += step;
      if (start >= end) {
        setCurrentPercentage(end);
        clearInterval(interval);
      } else {
        setCurrentPercentage(Math.round(start));
      }
    }, stepTime);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [percentage]);

  return (
    <div className="progress-bar-container">
      <div className="progress-bar" style={{ width: `${currentPercentage}%` }}>
        <span className="progress-bar-text">{text}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
